<script lang="ts">
import { computed, defineComponent } from "vue";
import { injectPool } from "@/shared/utils/injection";
import { getOutByIndex } from "@/shared/utils/outs";
import OutModePicker from "@/features/out/OutModePicker.vue";
import IoBanner from "@/features/probe/IoBanner.vue";
import ConfirmDirtyExitModal from "@/shared/components/ConfirmDirtyExitModal.vue";
import OutQuantities from "@/features/pool/dashboard/OutQuantities.vue";
import IoFooter from "@/features/probe/IoFooter.vue";

export default defineComponent({
  ...injectPool,
  components: {
    IoFooter,
    OutQuantities,
    ConfirmDirtyExitModal,
    OutModePicker,
    IoBanner,
  },
  provide() {
    return {
      out: computed(() => this.out),
    };
  },

  data() {
    return {
      showConfirm: false,
      next: () => {
        /* noop */
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isPoolDirty) {
      this.showConfirm = true;
      this.next = next;
    } else {
      next();
    }
  },

  computed: {
    outIdx() {
      return parseInt(this.$route.params.outIdx as string);
    },
    out() {
      return this.pool.outs.find((out) => out.index === this.outIdx)!;
    },
    label() {
      return getOutByIndex(this.out!.index).label;
    },
  },
});
</script>

<template>
  <div class="probe-view min-h-full flex flex-col">
    <confirm-dirty-exit-modal
      :show-confirm="showConfirm"
      @close="showConfirm = false"
      @next="next"
    />

    <io-banner
      :label="$t(label)"
      :with-chart="false"
      :io-index="out.index"
      :io-type="1"
    />
    <div class="lg:max-w-3xl lg:mx-auto grow w-full lg:grow-0 self-center">
      <out-mode-picker :out="out" />
    </div>

    <io-footer />
  </div>
</template>
